import builder from '../builder';
import CloudUpload from '../../streamline-icons/bold/cloud-upload.svg';

export default builder('IconCloudUploadBold', CloudUpload);
